import userflow from 'userflow.js'

export interface SetUserflowVisibleOptions {
  /**
   * Re-open the resource center panel, not just its launcher. Defaults to `true`.
   *
   * HubSpot chat passes `false`. Every resource-center open re-runs Userflow's own HubSpot
   * integration, which calls `HubSpotConversations.widget.hide()`, so re-opening the panel right
   * after a chat close feeds the loop that ENG-1461 is about. It also pops the help panel open
   * with no user action.
   */
  reopenResourceCenter?: boolean
}

/**
 * Hands the bottom-right corner back and forth between Userflow's resource center and a
 * third-party widget that lives in the same spot (HubSpot chat, the GitBook docs embed).
 *
 * Call with `false` before showing the other widget, and `true` once it closes so the user
 * lands back on the Userflow resource center they opened it from.
 */
export function setUserflowVisible(visible: boolean, opts: SetUserflowVisibleOptions = {}) {
  const { reopenResourceCenter = true } = opts
  try {
    userflow.setResourceCenterLauncherHidden(!visible)
    if (!visible) {
      userflow.closeResourceCenter()
    } else if (reopenResourceCenter) {
      userflow.openResourceCenter()
    }
  } catch {
    // Fallback to CSS if userflow not initialized
    const el = document.getElementById('userflow-ui')
    if (el) el.style.display = visible ? '' : 'none'
  }
}
